/**
 *Created by jmmartinez on 18/03/19
 *  v 1.1 30/04/2019 Eliminada importacion de tipos de componentes
 *  v 1.2 09/05/2019 Añadida código para pasar valorTextoInicial a los SelectorListaClase con lo que viene en foreign en el elemento
 *  v 1.3 12/06/2019 Añadido evento onBeforeSave
 *  v 1.4 30/08/2019 Añadido soporte campo obligatorioSiModificacion
 *                   Modificado CalcularCamposRows
 *                   Cambiados nombres de los eventos on
 *                   Añadido manejador de evento onClose del Dialogo de datos invalidos.
 *                   Cambiado método this.guardar, alque se le pasa como parametro el elemento modificado
 *  v 1.5 21/09/2019 Modificaciones para tener en cuenta cuando se usa un foreign JPA
 *                   Modificado para mandar a ComponenteEntrada la urlFK
 *  v 1.6  25/09/2019 Modificado CrearElementoNuevo para en CAMPOTIPO_FECHA llamar a getTimestampFromNowSinHora
 *  v 1.7  30/09/2019 Modificado para usar el nombre del paquete dinámicamente en la deteccion de clases.
 *  v 1.8  01/10/2019 Eliminado botón Volver
 *  v 1.9  02/10/2019 Creado método crearElementoClonado
 *                    Modificado ComponentDidMount con la opcion de clonar.
 *                    Creada la accion CLONAR
 *  v 1.10 17/10/2019 Modificado RenderCampo para variar la forma de obtener ValorTextoInicial según sea JPA o EJ2
 *  v 1.11 21/10/2019 Modificado RenderCampo, asignación de valor en caso no Objeto, para tener en cuenta valor de elemento y valor defecto del campo.
 *                    Modificado RenderCampo, asignacion de valor en caso de Objeto EJ2 y JPA, caso que el elemento venga vacio.
 *                    En método guardar, añadimos la condicion: que haya className.
 *  v 1.12 23/10/2019 Añadido TabOrderManager
 *                    Llamada a setFocusInicial(); en ComponentDidUpdate.
 *                    Pasamos tabOrderManager={this.tabOrderManager} a ComponenteEntrada
 *  v 1.13 25/10/2019 Añadido botón Guardar al TabOrderManager
 *  v 1.14 28/10/2019 Corregido tabIndex
 *  v 1.15 14/02/2020 Modificada la función renderCampo para los campos de tipo Check y Booleano que se use la función Boolean para que funcione bien.
 *  v 1.16 03/03/2020 En changeCampo añadida la transformación a mayúscula de las cadenas.
 *  v.1.17 10/02/2020 Añadido dialogoTitulo, dialogoTexto, dialogoTipo y onDialogoCerrado a las props.
 *                    Añadidas las propiedades anteriores al constructor y a ComponentWillReceiveProps.
 *                    Añadida en getRenderInput, la llamada a onBlur definida en elementoConfig del campo.
 *                    Añadido método blurCampo, que llama al onBlur del campo pasando el elemento completo de parámetro.
 *                    En el método onCloseDialogoInvalido añadida llamada a onDialogoCerrado.
 * v.1.18 19/03/2020  En el método calcularCamposRows, añadimos la condicion de visibilidad.
 * v.1.19 20/03/2020  En changeCampo, si está definido noMayus, no cambiamos a mayúsculas
 * v.1.20 06/04/2020  Añadida funcion onAntesCargarDatos en prop, para manipular el elemento antes de que se muestren sus campos.
 * v.1.21 09/04/2020  Añadida gestión de grupo de componentes
 * v.1.22 03/07/2020  En renderCampo añadido el caso de (campo.tipo === CAMPOTIPO_OPCIONES) para fijar el valor como Number
 * v.1.23 27/07/2020  En renderCampo añadida la llamada al metodo "mostrar" del campo para dinamicamente dedicdir si se muestra o no.
 * v.1.24 30/07/2020  Añadida la propiedad onPermitirAceptar para llamar a una función que permita bloquear el cierre ante ciertas condiciones.
 *                    Modificado el evento onAntesGuardar con la llamada a la propiedad onPermitirAceptar.
 * v.1.25 21/09/2020  Añadido uso de propiedad "nuevaLinea" en campos de ordenación para forzar salto
 * v.2.0  30/09/2020  Cambiado a framework2
 * v.2.1  06/10/2020  En el método guarda, eliminamos el campo: delete elementoPreparado.filaSeleccionada;
 * v.2.2  14/10/2020  Creada función para modificar desde fuera el elemento cuando se lanza el evento campo.onChangeCambiarElemento.
 *                    Este evento recoge el cambio del elemento completo, pero si hace falta cambiarlo tras una llamada asincrona, usamos la función que pasa el evento fModificar.
 *                    No podemos cambiar desde el formulario externo el elemento directamente pq el evento onChangeCambiarElemento puede colisionar en la actualización del state.
 * v.2.3  19/10/2020  Creada la propiedad usuario necesaria para la llamada al backend
 *
 * v.2.4  05/08/2021  Añadido delete elementoPreparado.rowIdx; en el metodo Guardar
 * v.2.5  28/03/2022  En método renderCampo, si estamos en accion de modificar y campo.readOnlyModificar, entonces modificamos el objeto campo al pasarlo a ComponenteEntrada
 *                    Modificado crearNuevoElemento, para llamar al evento onNuevoElemento y mergear su resultado: Object.assign(newElemento, onNuevoElemento());
 *
 * v.2.6 06/05/2022   Union Planifikator y Sidemur
 * v.2.7 23/05/2022   Añadido onNuevoElemento a Proptypes
 * v.2.8 26/05/2022   Modificado metodo Guardar, cambiando la llamada del callback a onGuardado && onGuardado(elementoGuardado);
 * v.2.9 01/07/2022   Añadida propiedad onAntesRenderCampos para modificar los campos antes de mostrarlos.
 *                    Modificado el método renderCampos para llamar a onAntesRenderCampos y tratar los nuevos campos.
 * v.2.10 04/09/2023  Añadida gestión del campo "saltolinea"
 * v.2.11 08/01/2025  Creado en el constructor this.componentsManager= new ComponentsManager(props.elementoConfig);
 *                    En el evento componentDidMount() añdida la llamada a this.componentsManager.procesarComponents())
 *
 * */

import React from 'react'

import PropTypes from 'prop-types';
import ClienteRestful from "../network/ClienteRestful";
import {Button, Tab} from "@blueprintjs/core";
import {Col, Container, Row} from "react-grid-system";
import ComponenteEntrada from "./ComponenteEntrada";
import { CAMPOTIPO_BOOLEANO, CAMPOTIPO_CADENA, CAMPOTIPO_CHECK, CAMPOTIPO_OPCIONES,
         CAMPOTIPO_FECHA, CAMPOTIPO_FECHAHORA} from "./TiposCampos";

import Dialogo from "../../blueprint/Dialogo"
import {prepararChildren} from "../utils/ComponentChildrenUtils";
import "../../resources/css/formulariobotonera.css"
import {getTimestampFromNowSinHora, getTimestampFromNow} from "../utils/DateUtils"
import {esForeign} from "../utils/ForeignUtils"
import {nombrePaquete, tipoPasarela} from "../../../dental/Configuracion";
import TabOrderManager from "../utils/TabOrderManager";
import "../../resources/css/grupocomponentes.css"
import {ACCION_NUEVO, ACCION_MODIFICAR, ACCION_CLONAR} from "./TiposAcciones"
import ComponentsManager from "../utils/ComponentsManager";



class FormularioDatos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            elementoConfig: props.elementoConfig,
            className: props.className,
            elemento: {},
            accion: props.accion,
            camposRows: this.calcularCamposRows(props.elementoConfig.campos),
            dialogoTexto: props.dialogoTexto,
            dialogoTipo: props.dialogoTipo,
            dialogoTitulo: props.dialogoTitulo,
            elementoInicial: {},
            camposModificados: false,
        }
        this.tabOrderManager= new TabOrderManager(props.elementoConfig);
        this.tabOrderManager.addTabOrder("guardar");
        //this.tabOrderManager.log();

        this.componentsManager= new ComponentsManager(props.elementoConfig);
    }

    componentDidMount() {
        const {elementoConfig, className, elemento, elementoOrigen, accion, onAntesMostrar} = this.props;
        let newElemento= elemento;

        /*
        console.log("FORMULARIODATOS - ComponentDidMount");
        console.log("Accion: ", accion);
        */

        switch(accion){
            case ACCION_NUEVO:  newElemento = this.crearElementoNuevo(); break;
            case ACCION_CLONAR: newElemento = this.crearElementoClonado(); break;
        }

        /*
        console.log("newElemento");
        console.log(newElemento);
        */

        //

        if (onAntesMostrar)
            newElemento = onAntesMostrar(newElemento);

        //Hacemos la llamada a procesarComponents después de guardar newElemento, para que opere sobre el elemento ya inicializado.
        this.setState({elementoConfig: elementoConfig, className: className, elemento: newElemento, accion: accion, elementoInicial: newElemento}
            ,() => this.componentsManager.procesarComponents()
        );
    }

    componentDidUpdate() {
        //Tenemos que hacer la llamada aquí porque es el punto en el que se han cargado los refs correctamente
        this.tabOrderManager.setFocusInicial();
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.campo !== prevState.campo) {
            newState.campo = nextProps.campo;
        }

        /*
        if (nextProps.elemento !== prevState.elemento) {
            let newElemento= nextProps.elemento;
            if (nextProps.onAntesMostrar)
                newElemento = nextProps.onAntesMostrar(newElemento);
            newState.elemento = newElemento;
            newState.elementoInicial = newElemento;
        }
        */

        if (nextProps.elementoConfig !== prevState.elementoConfig) {
            newState.elementoConfig = nextProps.elementoConfig;
        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    // -------------------------------------------------------------------------------------------------------------
    // CREAR ELEMENTOS
    // -------------------------------------------------------------------------------------------------------------


    crearElementoNuevo= () => {
        //Recorremos los campos y asignamos los obligatorios
        //console.log("!!!!crearElementoNuevo");
        const {elementoConfig} = this.state;
        const {onNuevoElemento} = this.props;
        let newElemento= {};
        elementoConfig.campos.forEach ( (campo) => {
            if (campo.valor){
                if (!tipoPasarela  || tipoPasarela === "EJ2") {
                    if (esForeign(campo.tipo) && typeof campo.valor === 'object') {
                        newElemento[campo.campo] = campo.valor.codigo;
                        if (!newElemento.foreign)
                            newElemento.foreign = {};
                        newElemento.foreign[campo.tipo] = campo.valor;
                    } else {
                        newElemento[campo.campo] = campo.valor;
                    }
                }
                else {
                    newElemento[campo.campo] = campo.valor;
                }
            }
            else {
                switch (campo.tipo){
                    case CAMPOTIPO_FECHAHORA: newElemento[campo.campo]= getTimestampFromNow(); break;
                    case CAMPOTIPO_FECHA: newElemento[campo.campo]= getTimestampFromNowSinHora(); break;
                }
            }
        });

        //Si existe el evento onNuevoElemento, lo llamamos y mergeamos lo que devuelve con los datos minimos creados.
        if (onNuevoElemento)
            Object.assign(newElemento, onNuevoElemento());

        return newElemento;
    }

    crearElementoClonado= () => {
        //Recorremos los campos y asignamos los obligatorios
        const {elementoConfig} = this.state;
        const {elementoOrigen} = this.props;
        let newElemento= {};
        elementoConfig.campos.forEach ( (campo) => {
            if (!tipoPasarela  || tipoPasarela === "EJ2") {
                if (esForeign(campo.tipo)) {
                    newElemento[campo.campo] = elementoOrigen[campo.campo]
                    if (!newElemento.foreign)
                        newElemento.foreign = {};
                    newElemento.foreign[campo.tipo] = elementoOrigen.foreign[campo.tipo];
                } else {
                    newElemento[campo.campo] = elementoOrigen[campo.campo];
                }
            }
            else {
                newElemento[campo.campo] = elementoOrigen[campo.campo]
            }
        });
        return newElemento;
    }

    // -------------------------------------------------------------------------------------------------------------
    // VALIDAR
    // -------------------------------------------------------------------------------------------------------------


    onCloseDialogoInvalido= () =>{
        const {onDialogoCerrado} = this.props;
        this.setState({dialogoTitulo: "", dialogoTexto: "", dialogoTipo: ""},
            ()=> { onDialogoCerrado && onDialogoCerrado(); }
        );
    }

    validarElemento= () => {
        const {elementoConfig, elemento, camposModificados} = this.state;
        const {onValidar} = this.props;
        let valido= true;
        let camposIncorrectos= [];
        if (onValidar){
            valido= onValidar(elemento);
        }
        else {
            elementoConfig.campos.forEach((campo) => {
                if (campo.obligatorio) {
                    //console.log(elemento[campo.campo]);
                    if (!elemento[campo.campo])
                        camposIncorrectos.push(campo.titulo)
                }
                else{
                    if (campo.obligatorioSiModificacion && camposModificados){
                        if (!elemento[campo.campo])
                            camposIncorrectos.push(campo.titulo)
                    }
                }
            });
            valido= camposIncorrectos.length === 0;
        }

        if (!valido){
            let dialogoTexto= camposIncorrectos.join(", ");
            dialogoTexto= "Los siguientes campos obligatorios no han sido completados: \r\n" + dialogoTexto;
            this.setState({dialogoTitulo: "Campos incorrectos", dialogoTexto: dialogoTexto, dialogoTipo: "ERROR"});
        }

        return valido;

    }


    // -------------------------------------------------------------------------------------------------------------
    // RENDER
    // -------------------------------------------------------------------------------------------------------------

    renderCampos= () => {
        const {className, camposRows, elemento, elementoConfig} = this.state;
        const {onAntesRenderCampos} = this.props;


        //console.log("FormularioDatos");
        //console.log ("camposRows: ", camposRows);

        let newCamposRows = camposRows;
        //Comprobamos si hay función para modificar los campos
        if (onAntesRenderCampos && elemento) {
            let newCampos = onAntesRenderCampos(elemento, elementoConfig.campos);
            //Los nuevos campos que se reciben deben procesarse para generar las rows
            newCamposRows= this.calcularCamposRows(newCampos);
        }

        return(
            <Container fluid={true} className={className}>
                {
                newCamposRows.map ( (row, index) => {
                    return this.renderCamposRow(row, index);
                    })
                }
            </Container>
        );
    }

    renderCamposRow= (row, index) => {
        const {filaClassName, camposModificados} = this.state;
        return(
            <Row key={index} className={filaClassName}>
                {
                    row.map ( (campo, indexRow) => {
                        let mostrarCampo= !campo.obligatorioSiModificacion || (campo.obligatorioSiModificacion && camposModificados);
                        if (mostrarCampo) {
                            if (campo.grupo)
                                return this.renderGrupoComponentes(campo, indexRow);
                            else
                                return this.renderCampo(campo, indexRow);
                        }
                    })
                }
            </Row>
        );
    }

    renderCampo = (campo, index) => {
        const {accion, elemento, columnaClassName, elementoConfig} = this.state;
        let valorTextoInicial= "";
        let valor= "";

        //console.log("RENDERCAMPO: ", campo.campo);

        if ( campo && campo.tipo && campo.tipo.includes(".") ) {
            if (campo.tipo.includes(nombrePaquete)) {
                if (tipoPasarela  && tipoPasarela === "JPA") {
                    valorTextoInicial = elemento ?  elemento[campo.campo] : {};
                    valor = elemento && elemento[campo.campo] ? elemento[campo.campo] : {};
                }
                else {
                    if (elemento && elemento.foreign && elemento.foreign[campo.tipo])
                        valorTextoInicial = elemento.foreign[campo.tipo].nombre;
                    valor = elemento && elemento[campo.campo] ? elemento[campo.campo] : "";
                    if (valor === "") {
                        valor = campo && campo.valor ? campo.valor.codigo : "";
                        valorTextoInicial = campo && campo.valor ? campo.valor.nombre : "";
                    }
                }
            }
            else {
                valorTextoInicial = campo.valor;
            }

        }
        else{

            //1. Asignamos el valor del elemento en ese campo
            if (campo.tipo === CAMPOTIPO_BOOLEANO || campo.tipo === CAMPOTIPO_CHECK) {
                valor = elemento && Boolean(elemento[campo.campo]);
            }
            else{
                if (campo.tipo === CAMPOTIPO_OPCIONES)
                    valor= elemento && Number(elemento[campo.campo]);
                else
                    valor= elemento && elemento[campo.campo] ? elemento[campo.campo] : "";
            }

            //2. Si es vacío, probamos con el valor por defecto del campo
            if (valor === ""){
                valor= campo.valor ? campo.valor : "";
            }
        }

        let urlServicio= elementoConfig.url;
        if (tipoPasarela  && tipoPasarela === "JPA")
            urlServicio= elementoConfig.urlFK;

        //Si tiene el metodo mostrar lo llamamos para ver si es visible:
        let mostrar= true;
        if (this.state && this.state.elemento && campo.mostrar){
            mostrar= campo.mostrar(elemento);
        }
        //console.log("Mostrar ", campo.campo, " -> ", mostrar);
        //console.log("Valor: ", campo.campo, " -> ", valor);

        //Si tiene el campo readOnlyModificar y estamos modificando, añadimos la propiedad readOnly para el render.
        let campoModificado= {...campo};
        if (accion === ACCION_MODIFICAR && campo.readOnlyModificar)
            campoModificado.readOnly= true;

        return (
                <Col key={index} md={campo.cols} className={columnaClassName}>
                    {mostrar && <ComponenteEntrada urlServicioRestful={urlServicio}
                                                         campo={campoModificado}
                                                         valor={valor}
                                                         valorTextoInicial={valorTextoInicial}
                                                         index={index}
                                                         onChange={this.changeCampo}
                                                         onUploadImage={this.uploadImage}
                                                         tabOrderManager={this.tabOrderManager}
                                                         componentsManager={this.componentsManager}
                                                         onBlur={this.blurCampo}/>
                    }
                </Col>
            )

    }

    renderGrupoComponentes = (campo, index) => {
        const {className, columnaClassName} = this.state;
        let camposRows= this.calcularCamposRows(campo.componentes);
        return(
            <Col key={index} md={campo.cols} className={columnaClassName}>
                <div className="grupocomponentes" key={index}>
                    <div className="grupocomponentes_titulo">{campo.titulo}</div>
                    <Container fluid={true} className={className}>
                        {
                            camposRows.map ( (row, index) => {
                                return this.renderCamposRow(row, index);
                            })
                        }
                    </Container>
                </div>
            </Col>

        );
    }

    calcularCamposRows = (campos) => {
        let anchoMaximo= 12;
        let camposRows= [];
        let anchoRowActual=0;
        let rowActual= [];

        campos.forEach ( (campo) => {
            if ( campo.visible == undefined || Boolean(campo.visible) === true) {
                //Si es un grupo hacemos un salto de row
                if (campo.saltolinea){
                    console.log("SALTO LINEA");
                    console.log("rowActual: ", rowActual);
                    anchoRowActual= 12;
                    //Añadimos la fila actual
                }
                else {
                    if (campo.grupoid) {
                        if (rowActual.length > 0) {
                            camposRows.push(rowActual);
                        }
                        campo.cols = 12;
                        rowActual = [campo];
                        anchoRowActual = campo.cols;
                    } else {
                        let nuevaLinea = campo.nuevalinea && Boolean(campo.nuevalinea);
                        if (campo.cols + anchoRowActual <= anchoMaximo && !nuevaLinea) {
                            rowActual.push(campo);
                            anchoRowActual += campo.cols;
                        } else {
                            //Añadimos la fila actual
                            camposRows.push(rowActual);
                            rowActual = [campo];
                            anchoRowActual = campo.cols;
                        }
                    }
                }
            }
        });
        //Añadimos la ultima row
        if (rowActual.length > 0)
            camposRows.push(rowActual);

        return camposRows;
    }

    // -------------------------------------------------------------------------------------------------------------
    // MODIFICACION ELEMENTOS
    // -------------------------------------------------------------------------------------------------------------


    changeCampo = (campo, valor) => {
        //console.log("FORMULARIODATOS - CHANGECAMPO");
        //console.log("campo: ",campo);

        const {elemento} = this.state;
        //¿Hay transformacion?
        let newValor= valor;
        if (campo.tipo === CAMPOTIPO_CADENA)
            if (campo.noMayus == undefined  || !Boolean(campo.noMayus))
                newValor= valor.toUpperCase();

        let newElemento = {...elemento};
        newElemento[campo.campo] = newValor;
        if (campo.onChangeCambiarElemento){
            console.log("Existe campo.onChangeCambiarElemento");
            //let newElementoCambiado= campo.onChangeCambiarElemento(newElemento, valor, this.modificarElemento);
            let newElementoCambiado= campo.onChangeCambiarElemento(newElemento, valor);
            if (newElementoCambiado)
                newElemento= {...newElementoCambiado};
        }

        /*
        console.log("!!!! onChangeCampo");
        console.log("campo.campo: ", campo.campo);
        console.log("newElemento: ", newElemento);
        */

        this.setState({elemento: newElemento, camposModificados: true});
        campo.onChange && campo.onChange(valor);

    }

    modificarElemento= (newElemento) => {
        //console.log("MODIFICAR ELEMENTO:", newElemento);
        this.setState({elemento: newElemento, camposModificados: true});
    }

    blurCampo = (campo) => {
        const {elemento} = this.state;
        if (campo.onBlur)
            campo.onBlur(elemento);
    }

    uploadImage = () => {
        //console.log("upload image");
    }


    // -------------------------------------------------------------------------------------------------------------
    // GUARDADO
    // -------------------------------------------------------------------------------------------------------------


    antesGuardar= () => {
        const {elemento, elementoInicial} = this.state;
        const {onPermitirAceptar, onAntesGuardar} = this.props;


        if (onPermitirAceptar){
            let puedeCerrar= onPermitirAceptar(elemento);
            //console.log("puedeCerrar", puedeCerrar);
            if (!Boolean(puedeCerrar) ) {
                //console.log("No puede Cerrar!");
                return;
            }
        }


        //Validamos
        if (!this.validarElemento()){
            return;
        }


        if (onAntesGuardar){
            let newElemento= onAntesGuardar(elemento, elementoInicial);
            this.guardar(newElemento, elemento);
        }
        else{
            this.guardar(elemento, elemento);
        }
    }

    //Pasamos el elemento completo, que lleva los valores de los campos condicionales, que se eliminan en onAntesGuardar
    guardar= (elemento, elementoCompleto) => {
        const {elementoConfig} = this.state;
        const {onGuardado, onGuardar, usuario} = this.props;

        //Obtenemos el codigo de usuario
        let usuarioCodigo= usuario ? usuario.codigo : 0;

        //Eliminamos el campo Nivel
        let elementoPreparado= {...elemento};
        delete elementoPreparado.nivel;
        delete elementoPreparado.filaSeleccionada;
        delete elementoPreparado.modificado; //nuevo
        delete elementoPreparado.guardado; //nuevo
        delete elementoPreparado.estadoRow; //nuevo
        delete elementoPreparado.rowIdx; //nuevo 2

        //Asignamos campos prefijados
        if (elementoConfig.camposPrefijados){
            elementoConfig.camposPrefijados.forEach( (campo) => {
                elementoPreparado[campo.campo]= campo.valor;
            });
        }


        if (onGuardar)
            elementoPreparado= onGuardar(elementoPreparado);

        console.log("GUARDAR");

        //console.log(usuario);
        console.log(elementoPreparado);

        if (elementoConfig.url && elementoConfig.className){
            let urlPost= elementoConfig.url + elementoConfig.className + "/" + usuarioCodigo;
            const clienteRestful = new ClienteRestful().setUrl(urlPost);
            console.log("urlPost: ", urlPost);
            clienteRestful.doPost(elementoPreparado, response => {
                let elementoGuardado= response;
                console.log("response: ", response);
                if (clienteRestful.exito && response) {
                    //onGuardado && onGuardado(elementoCompleto);
                    console.log("Guardado!");
                    onGuardado && onGuardado(elementoGuardado);
                }
            });
        }

    }


    render() {
        const {elemento, className, dialogoTitulo, dialogoTexto, dialogoTipo} =  this.state;
        const {children} = this.props;
        let childrenPreparado= prepararChildren(elemento, children, false);

        //console.log("FormularioDatos - Render");
        //console.log(elemento);
        //console.log(elementoConfig.campos);

        return (
            <>
                <Dialogo titulo={dialogoTitulo} mensaje={dialogoTexto} tipo={dialogoTipo} onClose={this.onCloseDialogoInvalido}/>
                <Container fluid={true} className={className}>
                    {
                        this.renderCampos()
                    }
                </Container>

                {
                    childrenPreparado &&
                    childrenPreparado.map( (child, index) => {
                        return (
                            <Tab key={index} id={child.props.titulo} title={child.props.titulo}
                                 panel={<> {child} </>}
                            />
                        );
                    })
                }
                <div className="botonera" tabIndex="-1">
                    <Button icon="saved" className="boton" text="Guardar" onClick={this.antesGuardar}
                            tabIndex="-1"
                            elementRef={ this.tabOrderManager ? this.tabOrderManager.getRef("guardar") : null } />
                </div>
            </>
        );
    }
}



FormularioDatos.propTypes = {
    elementoConfig: PropTypes.object.isRequired,
    className: PropTypes.string,
    elemento: PropTypes.object,
    onValidar: PropTypes.func,
    onGuardar: PropTypes.func,
    onGuardado: PropTypes.func,
    onAntesGuardar: PropTypes.func,
    onAntesMostrar: PropTypes.func,
    elementoOrigen: PropTypes.object,
    onNuevoElemento: PropTypes.func,

    dialogoTexto: PropTypes.string,
    dialogoTitulo: PropTypes.string,
    dialogoTipo: PropTypes.string,
    onDialogoCerrado: PropTypes.func,

    onPermitirAceptar: PropTypes.func,
    usuario: PropTypes.object,

    onAntesRenderCampos: PropTypes.func,
}

export default FormularioDatos
